import {
  get,
  post,
  postByOtherDomain,
  put,
  del,
  postWithStatusCode
} from '../configApi'

export async function insertCourse(body) {
  return await post(`/course/manage/insert`, body)
}
export async function updateCourse(body) {
  return await put(`/course/manage/update`, body)
}
export async function updateActive(body) {
  return await put(`/course/manage/active`, body)
}

export async function updateLectureActive(body) {
  return await put(`/course/lecture/manage/active`, body)
}

export async function getCourse(params) {
  return await get(`/course/list/admin`, params)
}
export async function getCourseById(params) {
  return await get(`/course/detail/admin`, params)
}

export async function moveCourseToBin(body) {
  return await post(`/course/manage/trash`, body)
}
export async function getCourseListBin(params) {
  return await get(`/course/list/trash`, params)
}

//section
export async function reorderSection(body) {
  return await put(`/course/manage/setsection`, body)
}
export async function insertSection(body) {
  return await post(`/course/section/manage/insert`, body)
}
export async function updateSection(body) {
  return await put(`/course/section/manage/update`, body)
}
export async function deleteSection(body) {
  return await del(`/course/section/manage/delete`, body)
}
export async function getSection(params) {
  return await get(`/course/section/detail`, params)
}

//lecture
export async function reorderLecture(body) {
  return await put(`/course/section/manage/setlecture`, body)
}
export async function insertLecture(body) {
  return await post(`/course/lecture/manage/insert`, body)
}
export async function updateLecture(body) {
  return await put(`/course/lecture/manage/update`, body)
}
export async function deleteLecture(body) {
  return await del(`/course/lecture/manage/delete`, body)
}

//book
export async function insertBook(body) {
  return await post(`/book/manage/insert`, body)
}
export async function updateBook(body) {
  return await put(`/book/manage/update`, body)
}

//blog
export async function insertBlog(body) {
  return await post(`/blog/manage/insert`, body)
}
export async function updateBlog(body) {
  return await put(`/blog/manage/update`, body)
}
export async function getDetailBlog(body) {
  return await get(`/uploadfile/preview/blog/`, body)
}

//report
export async function getReportCourse(params) {
  return await get(`/report/course/listcourse`, params)
}
export async function getRelatedCourse(params) {
  return await get(`/report/course/listrelatecourse`, params)
}
export async function getReportStudentInCourse(idcourse) {
  return await get(`/report/course/liststudent/course`, idcourse)
}
export async function getReportStudentHistory(params) {
  return await get(`/report/course/history`, params)
}
export async function getReportExamScore(params) {
  return await get(`/report/exam/listscore`, params)
}
export async function getListQuestionExam(params) {
  return await get(`/report/exam/listquestion`, params)
}
export async function getListQuestionExamByArticle(params) {
  return await get(`/report/exam/listquestion/article`, params)
}
export async function editScore(body) {
  return await post(`/report/exam/editscore`, body)
}
export async function deleteTicketExam(body) {
  return await del(`/exam/manage/deleteticketterm`, body)
}
export async function deleteTicketAll(body) {
  return await postWithStatusCode(`/exam/manage/deletetickeAll`, body)
}

//youtube
export async function insertYoutube(body) {
  return await post(`/youtube/manage/insert`, body)
}
export async function updateYoutube(body) {
  return await put(`/youtube/manage/update`, body)
}
export async function getPreviewYoutube() {
  return await get(`/uploadfile/preview/youtube`)
}

export async function buyProduct(body) {
  // return await postByOtherDomain(`https://demo2.2c2p.com/payment/4.0/paymentToken`,body)
  // return await postByOtherDomain(`https://demo2.2c2p.com/2C2PFrontend/PaymentActionV2/paymentToken`,body)
  return await postByOtherDomain(`https://demo2.2c2p.com/payment/4.0/paymentToken`, body)
}
//Bundles
export async function insertBundles(body) {
  return await post(`/bundles/manage/insert`, body)
}
export async function updateBundles(body) {
  return await put(`/bundles/manage/update`, body)
}
export async function updateBundlesActive(body) {
  return await put(`/bundles/manage/active`, body)
}
export async function deleteBundles(body) {
  return await del(`/bundles/manage/delete`, body)
}
export async function getListBundles(params) {
  return await get(`/bundles/list/admin`, params)
}
